import Howler from 'howler'
import Settings from '@/config/Settings'
import NarrationsFr from './music/narrations_fr.js'
import NarrationsEn from './music/narrations_en.js'
import Ambiences from './music/ambiences.js'
import Captations from './music/captations.js'
import {cdn, setToMs} from '@/commons/js/Utils'

Howler.mobileAutoEnable = false
Howler.autoSuspend = false

const rate = Settings.fast ? 4 : 1
// const rate = 1

// webkit
const webkit = {
  ambiences: setToMs(Ambiences),
  captations: setToMs(Captations),
  narrations_fr: setToMs(NarrationsFr),
  narrations_en: setToMs(NarrationsEn),
}

let start = 0
_.each(webkit, (types,k) => {
  _.each(types, m => m[0] += start)
  start += 3600000
})

export { webkit }
// end webkit

const music = type => {

  if(type == 'webkit') {
    return {
        webkit: new Howl({
        html5: true,
        rate: rate,
        volume: Settings.volume ? 1 : 0,
        src: [cdn(require('./music/webkit.mp3'))],
      })
    }
  } else {
    return {
      narrations_fr: new Howl({
        html5: true,
        rate: rate,
        volume: Settings.volume ? 1 : 0,
        src: [cdn(require('./music/narrations_fr.mp3'))],
        sprite: setToMs(NarrationsFr)
      }),
      narrations_en: new Howl({
        html5: true,
        rate: rate,
        volume: Settings.volume ? 1 : 0,
        src: [cdn(require('./music/narrations_en.mp3'))],
        sprite: setToMs(NarrationsEn)
      }),
      captations: new Howl({
        html5: true,
        rate: rate,
        volume: Settings.volume ? 1 : 0,
        src: [cdn(require('./music/captations.mp3'))],
        sprite: setToMs(Captations)
      }),
      ambiences: new Howl({
        html5: true,
        rate,
        volume: Settings.volume ? 1 : 0,
        src: [cdn(require('./music/ambiences.mp3'))],
        sprite: setToMs(Ambiences, true)
      })
    }
  }
}

export default music



// WEBPACK FOOTER //
// ./src/components/music/Howler.js